var map = {
	"./Begegnungszentrum.jpg": 3279,
	"./Betriebsgebäude in Herweg.jpg": 982,
	"./Bürogebäude in Untereschbach.jpg": 5264,
	"./Edeka Markt in Kürten Dürscheid.jpg": 4623,
	"./Mehrfamilienhaus in Bergisch Gladbach.jpg": 2969,
	"./Mehrfamilienhaus in Kürten-Dürscheid.jpg": 8673,
	"./Mehrfamilienhaus in Neschen.jpg": 7214,
	"./Neubau eines Wohn- und Geschäftshauses in Kürten-Dürscheid.jpg": 7953,
	"./verkleiner3/k-Begegnungszentrum.jpg": 3844,
	"./verkleiner3/k-Bürogebäude in Untereschbach.jpg": 9937,
	"./verkleiner3/k-Edeka Markt in Kürten Dürscheid.jpg": 3800,
	"./verkleiner3/k-Mehrfamilienhaus in Bergisch Gladbach.jpg": 2510,
	"./verkleiner3/k-Mehrfamilienhaus in Kürten-Dürscheid.jpg": 9680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4601;